export const CUSTOMER_SPOTLIGHT_SHORTCUTS = ["mod + K", "/"];

export function getCustomerSpotlightShortcutLabel() {
  const platform = typeof navigator === "undefined" ? "" : navigator.platform;
  return /Mac|iPhone|iPad|iPod/.test(platform) ? "⌘ K" : "Ctrl K";
}
